var map = {
	"./24-hours-delivery.svg": 86199,
	"./24.svg": 45956,
	"./365.svg": 79,
	"./Endocrinology.svg": 77874,
	"./Endovascular_surgery.svg": 91683,
	"./Therapy.svg": 428,
	"./account.svg": 65693,
	"./advantage-1.svg": 52579,
	"./advantage-2.svg": 73710,
	"./advantage-3.svg": 48342,
	"./advantage-4.svg": 3637,
	"./advantage-5.svg": 45339,
	"./advantage-6.svg": 38696,
	"./aging.svg": 89812,
	"./alert.svg": 52580,
	"./arr-white.svg": 97272,
	"./arrow-bread.svg": 28459,
	"./arrow-calendar.svg": 28702,
	"./arrow-chevron-down.svg": 82421,
	"./arrow-left-2.svg": 73773,
	"./arrow-more.svg": 10012,
	"./arrow-nav.svg": 18813,
	"./arrow-points.svg": 80369,
	"./arrow-right-2.svg": 23027,
	"./arrow-right.svg": 68790,
	"./attention.svg": 57351,
	"./baby-face.svg": 53161,
	"./baby.svg": 43838,
	"./back-2.svg": 58519,
	"./back.svg": 33758,
	"./bag.svg": 11578,
	"./bag2.svg": 26452,
	"./bazovoe.svg": 15604,
	"./biohaking.svg": 54700,
	"./blood-cell.svg": 35582,
	"./blood.svg": 88510,
	"./book.svg": 88322,
	"./breast.svg": 21189,
	"./calendar-2.svg": 69061,
	"./calendar-dark.svg": 81046,
	"./calendar.svg": 4075,
	"./call-2.svg": 70315,
	"./call-dark.svg": 96004,
	"./call.svg": 15367,
	"./card.svg": 56681,
	"./cardiology.svg": 17544,
	"./care.svg": 88049,
	"./career.svg": 98254,
	"./cellulite.svg": 29329,
	"./certificate.svg": 91894,
	"./charity.svg": 96783,
	"./check-2.svg": 45542,
	"./check-up.svg": 95861,
	"./check.svg": 80048,
	"./checklist.svg": 7269,
	"./child.svg": 53644,
	"./children.svg": 34486,
	"./clinic.svg": 77369,
	"./clock-2.svg": 30832,
	"./clock.svg": 25930,
	"./comfort.svg": 9273,
	"./company.svg": 65333,
	"./consultant.svg": 14898,
	"./cosmetic.svg": 13145,
	"./cosmetology.svg": 58423,
	"./couple.svg": 82476,
	"./cross.svg": 22261,
	"./cutlery.svg": 31285,
	"./depilation.svg": 13151,
	"./develop.svg": 77473,
	"./diagnosis.svg": 27557,
	"./diagnostics.svg": 64278,
	"./doctor-2.svg": 24987,
	"./doctor-3.svg": 29953,
	"./doctor.svg": 94782,
	"./document-2.svg": 8336,
	"./document.svg": 85904,
	"./done.svg": 12937,
	"./dzen.svg": 10095,
	"./eco-new.svg": 38924,
	"./eco1.svg": 1595,
	"./eco2.svg": 40188,
	"./eco3.svg": 32949,
	"./ecology.svg": 37465,
	"./electrocardiogram.svg": 90125,
	"./email.svg": 7706,
	"./eye-light.svg": 72477,
	"./eye.svg": 30298,
	"./family.svg": 16157,
	"./fertilization.svg": 84343,
	"./fertilnost.svg": 10969,
	"./fetus.svg": 20648,
	"./file.svg": 4968,
	"./filters.svg": 97874,
	"./first-aid-kit.svg": 31340,
	"./gastoenterology.svg": 49967,
	"./genetic.svg": 1890,
	"./girl.svg": 68837,
	"./globe.svg": 44010,
	"./golovnaya_bol.svg": 44527,
	"./growth.svg": 31916,
	"./guarantee.svg": 40224,
	"./gymnast-diet.svg": 51594,
	"./hand.svg": 87102,
	"./handshake.svg": 44302,
	"./hat.svg": 97828,
	"./healthcare-2.svg": 51657,
	"./healthcare-3.svg": 58144,
	"./healthcare.svg": 76811,
	"./heart-2.svg": 7832,
	"./heart-rate.svg": 51234,
	"./heart.svg": 40265,
	"./hepatology.svg": 56146,
	"./home-2.svg": 42251,
	"./home.svg": 60660,
	"./hospital-building.svg": 49265,
	"./hospital.svg": 93799,
	"./imac.svg": 55224,
	"./immune-system.svg": 48657,
	"./immunity.svg": 45707,
	"./info.svg": 5754,
	"./innovation.svg": 43005,
	"./jaw.svg": 42231,
	"./k31-big-2.svg": 99041,
	"./k31-big-3.svg": 395,
	"./k31-big.svg": 41001,
	"./kidneys.svg": 56283,
	"./kids.svg": 2365,
	"./kompl-obsl-densp.svg": 65079,
	"./kompleksnoe-obsl.svg": 23533,
	"./lechenie_boly.svg": 32872,
	"./link.svg": 24738,
	"./list-before.svg": 44926,
	"./list.svg": 44440,
	"./liver.svg": 71196,
	"./logo--white.svg": 29208,
	"./logo-2.svg": 17506,
	"./logo-dark.svg": 1112,
	"./logo-main.svg": 94324,
	"./logo.svg": 32189,
	"./luch_terapia-2.svg": 37173,
	"./luch_terapia.svg": 72282,
	"./lungs.svg": 1061,
	"./magnifier-2.svg": 87094,
	"./magnifier.svg": 75325,
	"./mammology.svg": 72219,
	"./man.svg": 77238,
	"./map-address.svg": 96102,
	"./map-marker-alt-solid.svg": 36586,
	"./map.svg": 70558,
	"./massage-2.svg": 16341,
	"./massage.svg": 85981,
	"./maxillofacial_surgery.svg": 81376,
	"./med-announce.svg": 92355,
	"./medical-tools.svg": 49933,
	"./medicine-2.svg": 82480,
	"./medicine-3.svg": 63314,
	"./medicine-4.svg": 69321,
	"./medicine.svg": 50685,
	"./methods.svg": 73689,
	"./migren.svg": 46189,
	"./mnogoplodnaya_beremennost.svg": 19955,
	"./modal-close.svg": 13259,
	"./moment.svg": 36231,
	"./more.svg": 82414,
	"./mri.svg": 53574,
	"./mrt-2.svg": 30701,
	"./mrt-dark.svg": 82116,
	"./mrt.svg": 66123,
	"./muzhskoye_obsledovaniye.svg": 57305,
	"./nephrology.svg": 46554,
	"./neurology-2.svg": 24124,
	"./neurology.svg": 94521,
	"./neurosurgery.svg": 1911,
	"./oborudovanie.svg": 8917,
	"./oborudovanie2.svg": 68923,
	"./obsl-gen.svg": 24697,
	"./obsl-s-gen-testom.svg": 66154,
	"./on_home.svg": 38507,
	"./oncology.svg": 74181,
	"./onko-urolog.svg": 67845,
	"./onkology.svg": 31482,
	"./online.svg": 28762,
	"./ophthalmologist.svg": 25623,
	"./oral-health.svg": 10887,
	"./organ.svg": 20695,
	"./osteopathy.svg": 52719,
	"./osteoporoz.svg": 14700,
	"./otolaryngologist.svg": 98365,
	"./parking.svg": 82733,
	"./patient.svg": 15273,
	"./patronage.svg": 75594,
	"./pdf.svg": 31822,
	"./pediatrics.svg": 20258,
	"./phlebology.svg": 18511,
	"./phone-2.svg": 39767,
	"./phone-3.svg": 36713,
	"./phone-call.svg": 63958,
	"./phone.svg": 86323,
	"./pills.svg": 91401,
	"./pin.svg": 46329,
	"./pincode-announce.svg": 21700,
	"./plastic_surgery.svg": 21039,
	"./play.svg": 59392,
	"./podgotovka_sad-shkola.svg": 54198,
	"./pohudenie_16-25.svg": 1480,
	"./pohudenie_26-35.svg": 44586,
	"./pohudenie_40.svg": 75646,
	"./pohudenie_7-15.svg": 61339,
	"./pohudenie_komfort.svg": 32440,
	"./popup-2.svg": 57868,
	"./popup-light.svg": 80251,
	"./popup.svg": 62030,
	"./pregnancy-banner.svg": 32995,
	"./premium.svg": 97061,
	"./prevention.svg": 70116,
	"./proctology.svg": 97111,
	"./protection.svg": 16166,
	"./psychotherapy.svg": 25326,
	"./psyhology.svg": 71640,
	"./puzzle.svg": 40289,
	"./quartz.svg": 91050,
	"./question.svg": 22902,
	"./radiation.svg": 74345,
	"./reception.svg": 16961,
	"./rehabilitation.svg": 53068,
	"./reset.svg": 52804,
	"./rheumatology.svg": 57643,
	"./safe.svg": 98572,
	"./sale.svg": 10876,
	"./satisfaction.svg": 55906,
	"./search.svg": 23271,
	"./skin.svg": 53849,
	"./small-intestine.svg": 3062,
	"./smoking.svg": 39063,
	"./snowflake-1.svg": 54001,
	"./snowflake-2.svg": 69074,
	"./snowflake-3.svg": 12275,
	"./snowflake-4.svg": 19658,
	"./snowflake-5.svg": 24477,
	"./snowflake-6.svg": 89240,
	"./snowflake-7.svg": 8741,
	"./snowflake.svg": 78820,
	"./solidarity.svg": 15276,
	"./star-blank.svg": 492,
	"./star-half-stroke.svg": 4711,
	"./star.svg": 68732,
	"./stat_mamoy.svg": 69653,
	"./stethoscope.svg": 82073,
	"./stomatology.svg": 29880,
	"./surgery-tools.svg": 78088,
	"./surgery.svg": 63821,
	"./tablets.svg": 52200,
	"./team.svg": 70283,
	"./teeth-protection.svg": 41864,
	"./telegram-upd.svg": 36277,
	"./telemedicine.svg": 32690,
	"./toes.svg": 41443,
	"./tomography.svg": 71869,
	"./traumatology.svg": 37167,
	"./urolog.svg": 79058,
	"./urolog_45.svg": 44134,
	"./urology-1.svg": 17120,
	"./urology-2.svg": 51994,
	"./user-2.svg": 42426,
	"./user.svg": 60434,
	"./uterus.svg": 42842,
	"./vaccinated.svg": 8296,
	"./vedenie_beremennosti.svg": 46022,
	"./video.svg": 71362,
	"./virus-2.svg": 63276,
	"./virus-3.svg": 87933,
	"./virus.svg": 9458,
	"./vk-upd.svg": 46375,
	"./wallet-2.svg": 31724,
	"./wallet.svg": 46008,
	"./whatsapp-2.svg": 19833,
	"./whatsapp-dark.svg": 71653,
	"./whatsapp-upd.svg": 36516,
	"./whatsapp.svg": 19290,
	"./woman.svg": 24762,
	"./work-from-home.svg": 97899
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49545;